import { Liabilities, LiabilityMonth } from './model';
import { Liability } from './liability.model';

export class SearchLiabilities extends Liabilities {
  public months: LiabilityMonth[] = [];
  public hasMoreFuture?: boolean;
  public hasMorePast?: boolean;
  public hasLiabilities?: boolean;
  public liabilities: Liability[];
}
